import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

/**
 * Finance ops summary for company admins (placeholder; requires financeOps module).
 */
export default function AdminFinanceWidget({ workspace }) {
  return (
    <Paper variant="outlined" sx={{ p: 2.5, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <AccountBalanceIcon color="primary" />
        <Typography variant="h6">Finance operations</Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Payout queues, reconciliation, and treasury signals
        {workspace?.size ? ` · ${workspace.size} org` : ''}.
      </Typography>
      <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'action.hover' }}>
        <Typography variant="subtitle2">Placeholder snapshot</Typography>
        <Typography variant="body2" color="text.secondary">
          Pending approvals: — · Settlements today: —
        </Typography>
      </Box>
    </Paper>
  );
}
